import ShipmentSummariesList from "./ShipmentSummariesList";

export default ShipmentSummariesList;
